import React from "react";
import { Link } from "react-router-dom";
import Reveal from "./Reveal";

const CheckIcon = () => (
  <svg className="check-icon" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
    <path
      fillRule="evenodd"
      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
      clipRule="evenodd"
    />
  </svg>
);

// SEZIONE 7 — CTA finale
export default function FinalCta() {
  return (
    <section className="cta-section" id="cta">
      <div className="container">
        <Reveal className="cta-content">
          <h2>Pronto a smettere di gestire la P.IVA con l'ansia?</h2>
          <p>Forfy è in beta privata. Richiedi accesso, i posti sono limitati.</p>
          <Link to="/richiedi-accesso" className="btn btn-cta">
            Richiedi accesso
          </Link>
          <div className="cta-trust">
            <span>
              <CheckIcon />
              Beta privata
            </span>
            <span>
              <CheckIcon />
              Posti limitati
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
